import * as Yup from "yup";

export const schemaEmails = Yup.object().shape({
  email: Yup.string()
    .email("Email field is wrong")
    .required("Email is a required field"),
  reEmail: Yup.string()
    .email("Re-type email field is wrong")
    .required("Re-type email is a required field"),
});
